/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var objectEntries = Object.entries || function (obj) {
  return Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
};

export default objectEntries;



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/polyfills/objectEntries.mjs
// module id = 2875
// module chunks = 0